import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import {ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT} from "../anamnesis/const";

export const selectOwnState = state => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectAnamnesisList = state => {
    return selectOwnState(state).anamnesisList
}
export const selectShowAnamnesis = state => {
    return selectOwnState(state).showAnamnesis
}

export const selectShowInfoLegendShown = state => {
    return selectOwnState(state).isInfoLegendShown
}

export const selectLastMedicalAssessment = (state) => {
    return selectAnamnesisList(state).find(el => el.templateKey === ALIGNER_TREATMENT_PHYSICIAN_ASSESSMENT)
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/list/selector.js